import React from "react";
import style from "../woundAssessment.module.scss";
import Loader from "../../../../static/images/spinner.svg";
import { Confirmation } from "../../../secondary";
import { Button } from "../../../primary";
import { useSelector } from "react-redux";

const DeleteConfirmationModal = ({ setShowDeleteConfirmation, assessReEvalCount, assessTitleContent, handleDelete }) => {
  const isDeleteAssessmentLoading = useSelector((state) => state.app.isDeleteAssessmentLoading);
  return (
    <Confirmation onClose={() => setShowDeleteConfirmation(false)} title={" "}>
      <div className="text-center pr-5 pl-5">
        {assessReEvalCount ? (
          <p className="pb-3">
            Do you wish to delete <b>{assessTitleContent}</b> including all the associated assessments?
          </p>
        ) : (
          <p className="pb-3">
            Do you wish to delete
            <br />
            <b>{assessTitleContent}?</b>
          </p>
        )}
        {isDeleteAssessmentLoading && (
          <div className="loader p-0 pb-4">
            <img src={Loader} alt="loading" />
          </div>
        )}
        <div className="mb-2">
          <Button
            value="Cancel"
            classes={{ className: `btn mr-3 ml-2 pb-2 pt-2 ${style.no_btn}` }}
            onClick={() => setShowDeleteConfirmation(false)}
          />
          <Button value="Delete" classes={{ className: `btn mr-2 pb-2 pt-2 ${style.yes_btn}` }} onClick={handleDelete} />
        </div>
      </div>
    </Confirmation>
  );
};

export default DeleteConfirmationModal;
